<template>
  <AiEducationLayout>
    <div class="ai-edu-admin-page">
      <ContentWrap title="开课教学班">
        <el-form :inline="true" :model="query" class="-mb-15px">
          <el-form-item label="学校">
            <el-select
              v-model="query.schoolId"
              class="!w-220px"
              clearable
              filterable
              placeholder="选择学校"
              @change="onSchoolChange"
            >
              <el-option v-for="s in schools" :key="s.id" :label="s.name" :value="s.id!" />
            </el-select>
          </el-form-item>
          <el-form-item label="学期">
            <el-select
              v-model="query.termId"
              class="!w-200px"
              clearable
              filterable
              placeholder="选择学期"
              @change="handleQuery"
            >
              <el-option v-for="t in terms" :key="t.id" :label="t.name" :value="t.id" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="handleQuery"><Icon icon="ep:search" />搜索</el-button>
            <el-button
              v-hasPermi="['ai-education:teaching-class:write']"
              plain
              type="primary"
              @click="openDialog()"
            >
              <Icon icon="ep:plus" />新增开课
            </el-button>
          </el-form-item>
        </el-form>
      </ContentWrap>
      <ContentWrap>
        <el-table v-loading="loading" :data="filteredList" border>
          <el-table-column prop="name" label="教学班" min-width="160" />
          <el-table-column label="学校" min-width="120">
            <template #default="{ row }">{{ row.schoolName || schoolName(row.schoolId) }}</template>
          </el-table-column>
          <el-table-column label="学期" min-width="120">
            <template #default="{ row }">{{ row.termName || termName(row.termId) }}</template>
          </el-table-column>
          <el-table-column label="课程" min-width="140">
            <template #default="{ row }">{{
              row.trainCourseName || courseName(row.trainCourseId) || (row.trainCourseId ? `课程 ${row.trainCourseId}` : '-')
            }}</template>
          </el-table-column>
          <el-table-column label="开课部门" min-width="120">
            <template #default="{ row }">{{ deptName(row.offerDeptId) }}</template>
          </el-table-column>
          <el-table-column label="教师" min-width="100">
            <template #default="{ row }">{{ teacherName(row.teacherId) }}</template>
          </el-table-column>
          <el-table-column prop="capacity" label="容量" width="80" />
          <el-table-column prop="credit" label="学分" width="80" />
          <el-table-column label="候补" width="80">
            <template #default="{ row }">
              <el-tag :type="row.waitlistEnabled ? 'success' : 'info'" size="small">
                {{ row.waitlistEnabled ? '开' : '关' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="startTime" label="开课" width="170" />
          <el-table-column prop="endTime" label="结课" width="170" />
          <el-table-column label="状态" width="90">
            <template #default="{ row }">
              <dict-tag :type="DICT_TYPE.AI_EDU_COMMON_STATUS" :value="row.status" />
            </template>
          </el-table-column>
          <el-table-column label="操作" width="160" fixed="right">
            <template #default="{ row }">
              <el-button
                v-hasPermi="['ai-education:teaching-class:write']"
                link
                type="primary"
                @click="openDialog(row)"
                >编辑</el-button
              >
              <el-button
                v-hasPermi="['ai-education:teaching-class:delete']"
                link
                type="danger"
                @click="handleDelete(row.id)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </ContentWrap>

      <Dialog v-model="dialogVisible" :title="form.id ? '编辑开课' : '新增开课'" width="620px">
        <el-form ref="formRef" :model="form" :rules="rules" label-width="110px">
          <el-form-item label="学校" prop="schoolId">
            <el-select
              v-model="form.schoolId"
              class="w-100%"
              filterable
              @change="onFormSchoolChange"
            >
              <el-option v-for="s in schools" :key="s.id" :label="s.name" :value="s.id!" />
            </el-select>
          </el-form-item>
          <el-form-item label="学期" prop="termId">
            <el-select
              v-model="form.termId"
              class="w-100%"
              clearable
              filterable
              :placeholder="formSchoolIsK12 ? 'K12 可不选学期' : '选择学期'"
            >
              <el-option v-for="t in formTerms" :key="t.id" :label="t.name" :value="t.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="课程" prop="trainCourseId">
            <el-select v-model="form.trainCourseId" class="w-100%" filterable>
              <el-option
                v-for="c in courses"
                :key="c.id"
                :label="c.name || c.title"
                :value="c.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="开课部门" prop="offerDeptId">
            <el-select v-model="form.offerDeptId" class="w-100%" clearable filterable>
              <el-option v-for="d in depts" :key="d.id" :label="d.name" :value="d.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="教学班名称" prop="name">
            <el-input v-model="form.name" />
          </el-form-item>
          <el-form-item label="教师" prop="teacherId">
            <el-select v-model="form.teacherId" class="w-100%" clearable filterable>
              <el-option
                v-for="u in teachers"
                :key="u.id"
                :label="u.nickname || u.username"
                :value="u.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="容量">
            <el-input-number v-model="form.capacity" :min="0" />
          </el-form-item>
          <el-form-item label="学分">
            <el-input-number v-model="form.credit" :min="0" :precision="1" :step="0.5" />
          </el-form-item>
          <el-form-item label="开启候补">
            <el-switch v-model="form.waitlistEnabled" />
          </el-form-item>
          <el-form-item label="开课时间">
            <el-date-picker
              v-model="form.startTime"
              class="!w-100%"
              type="datetime"
              value-format="YYYY-MM-DD HH:mm:ss"
            />
          </el-form-item>
          <el-form-item label="结课时间">
            <el-date-picker
              v-model="form.endTime"
              class="!w-100%"
              type="datetime"
              value-format="YYYY-MM-DD HH:mm:ss"
            />
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="form.status" class="w-100%">
              <el-option
                v-for="d in getIntDictOptions(DICT_TYPE.AI_EDU_COMMON_STATUS)"
                :key="d.value"
                :label="d.label"
                :value="d.value"
              />
            </el-select>
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button :loading="saving" type="primary" @click="submit">保存</el-button>
        </template>
      </Dialog>
    </div>
  </AiEducationLayout>
</template>

<script lang="ts" setup>
import * as AiEducationApi from '@/api/aiEducation'
import * as UniversityApi from '@/api/aiEducation/university'
import AiEducationLayout from '../../layout/AiEducationLayout.vue'
import request from '@/config/axios'
import { getSimpleDeptList } from '@/api/system/dept'
import { getSimpleUserList } from '@/api/system/user'
import { DICT_TYPE, getIntDictOptions } from '@/utils/dict'
import type { FormInstance, FormRules } from 'element-plus'

defineOptions({ name: 'AiEduOffering' })

const message = useMessage()
const loading = ref(false)
const saving = ref(false)
const list = ref<AiEducationApi.TeachingClassVO[]>([])
const schools = ref<AiEducationApi.SchoolVO[]>([])
const terms = ref<UniversityApi.TermSimpleVO[]>([])
const formTerms = ref<UniversityApi.TermSimpleVO[]>([])
const courses = ref<Array<{ id: number; name?: string; title?: string }>>([])
const depts = ref<Array<{ id: number; name: string }>>([])
const teachers = ref<Array<{ id: number; nickname?: string; username?: string }>>([])
const query = reactive<{ schoolId?: number; termId?: number }>({})
const dialogVisible = ref(false)
const formRef = ref<FormInstance>()
const form = reactive<Partial<AiEducationApi.TeachingClassVO>>({})
const K12_STAGES = new Set(['primary', 'junior', 'senior'])
const formSchoolIsK12 = computed(() => {
  const stage = schools.value.find((s) => s.id === form.schoolId)?.eduStage
  return !!stage && K12_STAGES.has(stage)
})
const rules = computed<FormRules>(() => ({
  schoolId: [{ required: true, message: '请选择学校', trigger: 'change' }],
  ...(formSchoolIsK12.value
    ? {}
    : { termId: [{ required: true, message: '请选择学期', trigger: 'change' }] }),
  trainCourseId: [{ required: true, message: '请选择课程', trigger: 'change' }],
  name: [{ required: true, message: '请输入教学班名称', trigger: 'blur' }]
}))

const filteredList = computed(() =>
  list.value.filter((item) => !query.termId || item.termId === query.termId)
)

const schoolName = (id?: number) => schools.value.find((s) => s.id === id)?.name || '-'
const termName = (id?: number) => terms.value.find((t) => t.id === id)?.name || (id ? `#${id}` : '-')
const courseName = (id?: number) => {
  const c = courses.value.find((item) => item.id === id)
  return c?.name || c?.title || (id ? `#${id}` : '-')
}
const deptName = (id?: number) => depts.value.find((d) => d.id === id)?.name || (id ? `#${id}` : '-')
const teacherName = (id?: number) => {
  const u = teachers.value.find((t) => t.id === id)
  return u?.nickname || u?.username || (id ? `#${id}` : '-')
}

const loadOptions = async () => {
  const [schoolList, courseList, deptList, userList] = await Promise.all([
    AiEducationApi.getSchoolOptions().catch(() => AiEducationApi.getSchoolList()),
    // 仅智课课程包内课程，禁止回退全站 train 列表（会混入无关课）
    AiEducationApi.getTrainCourseOptions(200).catch(() => []),
    getSimpleDeptList(),
    getSimpleUserList()
  ])
  schools.value = schoolList || []
  const rawCourses = (courseList as any)?.list || courseList || []
  courses.value = (Array.isArray(rawCourses) ? rawCourses : []).map((c: any) => ({
    ...c,
    id: c.id,
    name: c.name || c.title || `课程 #${c.id}`,
    title: c.title || c.name
  }))
  depts.value = deptList || []
  teachers.value = userList || []
}
const loadTerms = async (schoolId?: number) => {
  terms.value = schoolId ? (await UniversityApi.getTermSimpleList(schoolId)) || [] : []
}
const loadFormTerms = async (schoolId?: number) => {
  formTerms.value = schoolId ? (await UniversityApi.getTermSimpleList(schoolId)) || [] : []
}
const load = async () => {
  loading.value = true
  try {
    list.value =
      (await AiEducationApi.getTeachingClassList({ schoolId: query.schoolId })) || []
  } finally {
    loading.value = false
  }
}
const onSchoolChange = async () => {
  query.termId = undefined
  await loadTerms(query.schoolId)
  await load()
}
const onFormSchoolChange = async (schoolId?: number) => {
  form.termId = undefined
  await loadFormTerms(schoolId)
  if (formSchoolIsK12.value) {
    form.waitlistEnabled = false
  }
}
const handleQuery = () => load()
const openDialog = async (row?: AiEducationApi.TeachingClassVO) => {
  Object.assign(form, {
    id: row?.id,
    schoolId: row?.schoolId ?? query.schoolId,
    termId: row?.termId ?? query.termId,
    trainCourseId: row?.trainCourseId,
    offerDeptId: row?.offerDeptId,
    name: row?.name || '',
    teacherId: row?.teacherId,
    capacity: row?.capacity ?? 0,
    credit: row?.credit ?? 0,
    waitlistEnabled: row?.waitlistEnabled ?? true,
    startTime: row?.startTime,
    endTime: row?.endTime,
    status: row?.status ?? 20
  })
  await loadFormTerms(form.schoolId)
  if (!row?.id && formSchoolIsK12.value) {
    form.waitlistEnabled = false
    form.termId = undefined
  }
  dialogVisible.value = true
}
const submit = async () => {
  await formRef.value?.validate()
  saving.value = true
  try {
    await AiEducationApi.saveTeachingClass(form)
    message.success('保存成功')
    dialogVisible.value = false
    await load()
  } finally {
    saving.value = false
  }
}
const handleDelete = async (id?: number) => {
  if (!id) return
  await message.delConfirm()
  await AiEducationApi.deleteTeachingClass(id)
  message.success('删除成功')
  await load()
}

onMounted(async () => {
  await loadOptions()
  await load()
})
</script>
